import { Outlet } from 'react-router-dom'
import GroupLeaderBottomNav from '../components/GroupLeaderBottomNav'

export default function GroupLeaderLayout() {
  return (
    <>
      <Outlet />
      <GroupLeaderBottomNav />
    </>
  )
}